var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopologyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e9dqyonjfa)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#545454"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-1.834.986c-.054.01-.11.014-.166.014h-5v1.5a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1h6c.056 0 .112.005.166.014A3.001 3.001 0 0 1 24 3a3 3 0 0 1-5.834.986zM15 11a1 1 0 1 0 0 2h1c.056 0 .112-.005.166-.014A3.001 3.001 0 0 0 22 12a3 3 0 0 0-5.834-.986A1.008 1.008 0 0 0 16 11h-1zm-2 7.5a1 1 0 1 0-2 0V21a1 1 0 0 0 1 1h6c.056 0 .112-.005.166-.014A3.001 3.001 0 0 0 24 21a3 3 0 0 0-5.834-.986A1.008 1.008 0 0 0 18 20h-5v-1.5zm6-7.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm1 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM9.974 14.16a.9.9 0 0 1 .062-.524.899.899 0 0 1 .824-.545h.05a1.09 1.09 0 1 0 0-2.182h-.094a.9.9 0 0 1-.823-.545v-.044a.9.9 0 0 1 .18-.993l.033-.032A1.091 1.091 0 1 0 8.662 7.75l-.033.033a.9.9 0 0 1-.993.18.9.9 0 0 1-.545-.824v-.05a1.09 1.09 0 0 0-2.182 0v.094a.9.9 0 0 1-.545.823H4.32a.9.9 0 0 1-.993-.18l-.032-.032A1.091 1.091 0 1 0 1.75 9.338l.033.033a.9.9 0 0 1 .18.993.9.9 0 0 1-.824.589h-.05a1.091 1.091 0 0 0 0 2.181h.094a.9.9 0 0 1 .823.546.9.9 0 0 1-.18.993l-.032.033a1.09 1.09 0 1 0 1.543 1.543l.033-.033a.9.9 0 0 1 .993-.18.9.9 0 0 1 .589.824v.05a1.091 1.091 0 0 0 2.182 0v-.094a.9.9 0 0 1 .545-.823.9.9 0 0 1 .993.18l.032.033a1.091 1.091 0 1 0 1.544-1.544l-.033-.033a.9.9 0 0 1-.242-.469zm-2.346-2.159a1.636 1.636 0 1 1-3.272 0 1.636 1.636 0 0 1 3.272 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "e9dqyonjfa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopologyIcon);
export default __webpack_public_path__ + "static/media/topologyIcon.2c997f99ec2370dd86be1c693c83c634.svg";
export { ForwardRef as ReactComponent };